export default __webpack_public_path__ + "media/images/preview-2e1b40bccb6e0968d3f58585f8dc3110.png";